export const incomeCategories = [
  { value: "Share Investment", label: "Share Investment" },
  { value: "Salary", label: "Salary" },
  { value: "Debt Return", label: "Debt Return" },
  { value: "Other", label: "Other" },
];

export const expenseCategories = [
  { value: "Household", label: "Household" },
  { value: "Personal", label: "Personal" },
  { value: "Transportation", label: "Transportation" },
  { value: "Food", label: "Food" },
  { value: "Education", label: "Education" },
  { value: "Medical", label: "Medical" },
  { value: "Entertainment", label: "Entertainment" },
  { value: "other", label: "other" },
];
